module.exports = __webpack_public_path__ + "static/media/team4.8ebe03a0.jpg";